import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW6901ProposalTabModel } from "../kymw6901-proposal-tab.model";


/**
 * 提案ステータスを採用で更新するサービス
 *
 * @export UpdateSuggestionStatusRecruimentService
 * @class UpdateSuggestionStatusRecruimentService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateSuggestionStatusRecruimentService extends PlessJsonResponderSub<null> {
  private model: KYMW6901ProposalTabModel;
  private proposalStatus: string;
  private successFunc = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateSuggestionStatusRecruimentService
   */
  private getBody(): PlessRequest {

    return new PlessRequest({
      update: {
        updateSuggestionStatusRecruiment: {
          parameter: {
            ProposalId: this.model.newGoodsProposal.proposalId,
            ProposalStatus: this.proposalStatus,
            ProposalBuyerId: this.model.newGoodsProposal.buyerUserId
          }
        }
      }

    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateSuggestionStatusRecruimentService
   */
  execute(model: KYMW6901ProposalTabModel, proposalStatus: string, successFunc?: () => void): void {
    this.model = model;
    this.proposalStatus = proposalStatus;
    this.successFunc = successFunc;
    this.send('updateSuggestionStatusRecruiment', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * 
   * @memberof UpdateSuggestionStatusRecruimentService
   */
  success(): void {
    if (this.successFunc) {
      this.successFunc();
    }
  }
}

